<template>
  <v-container fluid
               style="height: 100%"
               :class="[$route.name === 'Conversaciones' ? 'no-padding' : '']">
    <transition :name="transitionName">
      <router-view/>
    </transition>
  </v-container>
</template>
<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      isCloudTask: state => state.auth.isCloudTask
    })
  },
  props: ['transitionName']
}
</script>

<style>
  @media (max-width: 960px) {
    .no-padding {
      padding: 0;
    }
  }
</style>
